<template>
  <div>
    <el-form :model="addRowTypeForm" ref="addRowType" label-width="50px">
      <el-form-item
        prop="type"
        label="类型:"
        :rules="[{ required: true, message: '请选择', trigger: 'blur' }]"
      >
        <el-select placeholder="请选择" v-model="addRowTypeForm.type" clearable>
          <el-option
            v-for="item in typeItems"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-button type="primary" @click="addRow">添加</el-button>
      </el-form-item>
    </el-form>
    <el-form :model="formModel" ref="formModel">
      <el-table
        class="addRowTypeTable"
        :data="formModel.formDataaccidentItemsAddParamList"
        style="width: 100%"
      >
        <el-table-column label="类型" width="200px">
          <template slot-scope="scope">
            <div>{{ scope.row.item }}</div>
          </template>
        </el-table-column>
        <el-table-column label="定损金额">
          <template slot-scope="scope">
            <el-form-item
              :prop="
                'formDataaccidentItemsAddParamList.' +
                  scope.$index +
                  '.lossAmount'
              "
              :rules="tableRules.lossAmount"
            >
              <span>{{ scope.row.lossAmount || '--' }}</span>
              <!-- <el-input
                v-model="scope.row.lossAmount"
                placeholder="请输入"
                v-limit-money="true"
                v-delete-emoji
              ></el-input> -->
            </el-form-item>
          </template>
        </el-table-column>
        <!-- 应收收取方式 -->
        <el-table-column label="应收收取方式">
          <template slot-scope="scope">
            <el-form-item
              :prop="
                'formDataaccidentItemsAddParamList.' +
                  scope.$index +
                  '.receivableType'
              "
              :rules="tableRules.receivableType"
            >
              <el-select
                placeholder="请选择"
                v-model="scope.row.receivableType"
                @change="receivableMethodChange(scope.$index)"
              >
                <el-option label="指定金额收取" :value="1"></el-option>
                <el-option label="按占比收取" :value="2"></el-option>
              </el-select>
            </el-form-item>
          </template>
        </el-table-column>
        <!-- 应收占比 -->
        <el-table-column label="应收占比">
          <template slot-scope="scope">
            <el-form-item
              :prop="
                'formDataaccidentItemsAddParamList.' +
                  scope.$index +
                  '.receivableProportion'
              "
              :rules="
                +scope.row.receivableType === 2
                  ? tableRules.receivableProportion
                  : []
              "
              :show-message="+scope.row.receivableType === 2"
            >
              <el-input
                v-number:percent
                v-model.number="scope.row.receivableProportion"
                v-show="+scope.row.receivableType === 2"
                @input="value => receivableRatioChange(value, scope.$index)"
              >
                <template slot="append"
                  >%</template
                >
              </el-input>
              <span
                v-show="
                  +scope.row.receivableType === 1 || !scope.row.receivableType
                "
              >
              --</span
              >
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column label="应收金额">
          <template slot-scope="scope">
            <el-form-item
              :prop="
                'formDataaccidentItemsAddParamList.' +
                  scope.$index +
                  '.receivableAmount'
              "
              :rules="tableRules.receivableAmount"
            >
              <el-input
                v-model="scope.row.receivableAmount"
                placeholder="请输入"
                v-limit-money="true"
                v-delete-emoji
                v-show="+scope.row.receivableType === 1"
                :disabled="+allLossAmount <= 0"
              ></el-input>
              <span
                v-show="
                  +scope.row.receivableType === 2 || !scope.row.receivableType
                "
                >{{ scope.row.receivableAmount || '--' }}</span
              >
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column label="备注">
          <template slot-scope="scope">
            <el-form-item
              :prop="
                'formDataaccidentItemsAddParamList.' +
                  scope.$index +
                  '.receivableAmount'
              "
            >
              <el-input
                placeholder="请输入"
                v-model="scope.row.remarks"
                maxlength="500"
                v-delete-emoji
              ></el-input>
            </el-form-item>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button type="text" @click="delRow(scope.$index)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-form>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { queryByType } from '@/api/domain/carsService'

export default {
  props: ['allLossAmount'],
  data() {
    return {
      addRowTypeForm: {
        type: '', // 添加财务项类型
      },
      typeItems: [],
      typeItemsObj: {},
      formModel: {
        formDataaccidentItemsAddParamList: [],
      }, // 财务项表单
      tableRules: {
        lossAmount: {
          required: true,
          message: '定损金额不能为空',
          trigger: 'change',
        },
        receivableAmount: {
          required: true,
          message: '应收金额不能为空',
          trigger: 'change',
        },
        receivableProportion: {
          // eslint-disable-next-line vue/no-unused-properties
          required: true,
          // eslint-disable-next-line vue/no-unused-properties
          message: '应收占比不能为空',
          // eslint-disable-next-line vue/no-unused-properties
          trigger: ['change', 'blur'],
        },
        receivableType: {
          required: true,
          message: '应收收取方式',
          trigger: 'change',
        },
      }, // 财务项规则
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
  },
  created() {
    this.getFinanceItems()
  },
  methods: {
    // 添加财务项
    addRow() {
      this.$refs.addRowType.validate((valid) => {
        const { type } = this.addRowTypeForm
        /**
         * type
         * key：value
         * 开发、测试环境 -- 180：三者；181:事故罚金；182:物损费；183:保险上浮费；185:人伤费；186:加速折旧费
         * 预发、灰度、正式环境 -- 165：三者； 166：主车； 167:事故罚金；168:物损费；169:保险上浮费；170:人伤费；171:加速折旧费
         * * */
        // 判断列表中是否存在同类型费项
        const selectedLabel = this.typeItems.find(
          (item) => item.value === type,
        ).label
        const sameItem = this.formModel.formDataaccidentItemsAddParamList.find(
          (item) => item.item === selectedLabel,
        )
        if (sameItem) {
          this.$message.error(`${selectedLabel}已存在，请勿重复添加`)
          return
        }
        if (valid) {
          this.formModel.formDataaccidentItemsAddParamList.push({
            item: selectedLabel, // 事故事项
            lossAmount: this.allLossAmount || '', // 定损金额
            receivableAmount: '', // 应收金额
            remarks: '', // 备注
            tenantId: this.userInfo.tenantId,
            receivableType:
              Number(type) === 183 || Number(type) === 169 ? 1 : 2, // 1-指定金额收取，2-按占比收取
            receivableProportion: '', // 应收占比
          })
          this.addRowTypeForm.type = ''
        }
      })
      this.$emit(
        'setRowLength',
        this.formModel.formDataaccidentItemsAddParamList.length,
      )
    },
    // 删除财务项
    delRow(index) {
      this.formModel.formDataaccidentItemsAddParamList.splice(index, 1)
      this.$emit(
        'setRowLength',
        this.formModel.formDataaccidentItemsAddParamList.length,
      )
    },
    getTotal() {
      let lossAmountTotal = 0
      let receivableAmountTotal = 0
      const arr = this.formModel.formDataaccidentItemsAddParamList
      if (arr.length > 0) {
        arr.forEach((item) => {
          lossAmountTotal += Number(item.lossAmount) || 0
          receivableAmountTotal += Number(item.receivableAmount) || 0
        })
      }
      return { lossAmountTotal, receivableAmountTotal }
    },
    // eslint-disable-next-line vue/no-unused-properties
    validateFinance() {
      this.formModel.formDataaccidentItemsAddParamList.forEach((ele) => {
        if (!ele.lossAmount || ele.lossAmount === '--') ele.lossAmount = ''
      })
      let flag = false
      this.$refs.formModel.validate((vaild) => {
        vaild ? (flag = true) : (flag = false)
      })
      return flag
    },
    // 获取事故财务项下拉框数据
    getFinanceItems() {
      queryByType({
        type: 5,
      }).then(({ code, data }) => {
        if (code === 1 && data.length > 0) {
          data.forEach((item) => {
            this.typeItemsObj[Number(item.id)] = item.itemName
            this.typeItems.push({
              label: item.itemName,
              value: Number(item.id),
            })
          })
        }
      })
    },

    // 应收收取方式change
    receivableMethodChange(index) {
      this.formModel.formDataaccidentItemsAddParamList[index].receivableAmount =
        '' // 应收金额
      this.formModel.formDataaccidentItemsAddParamList[
        index
      ].receivableProportion = '' // 应收占比
    },

    // 应收占比change
    receivableRatioChange(value, index) {
      let filterValue = value.replace(/[^\d]/g, '')
      filterValue = Number(filterValue) > 100 ? 100 : filterValue
      const result = filterValue || ''

      this.formModel.formDataaccidentItemsAddParamList[
        index
      ].receivableProportion = result
      this.formModel.formDataaccidentItemsAddParamList[
        index
      ].receivableAmount = result
        ? ((Number(this.allLossAmount) * Number(result)) / 100).toFixed(2)
        : ''
    },
  },
  watch: {
    'formModel.formDataaccidentItemsAddParamList': {
      handler() {
        this.$emit(
          'receivableAmountTotal',
          this.getTotal().receivableAmountTotal,
        )
      },
      immediate: true,
      deep: true,
    },
    allLossAmount(value) {
      this.formModel.formDataaccidentItemsAddParamList.forEach((item) => {
        item.lossAmount = Number(value) || ''
        if (Number(item.receivableType) === 1 && !value) {
          item.receivableAmount = ''
        }
        if (Number(item.receivableType) === 2) {
          item.receivableAmount =
            item.receivableProportion &&
            ((Number(value) * Number(item.receivableProportion)) / 100).toFixed(
              2,
            )
        }
      })
      this.$refs.formModel.validate()
    },
  },
}
</script>
<style scoped lang="scss">
::v-deep .el-form-item__label:before {
  content: '';
  color: #f56c6c;
  margin-right: 4px;
  display: none !important;
}
// .addRowTypeTable ::v-deep .el-form-item--small.el-form-item {
//   margin-bottom: 0px !important;
// }
.addRowTypeTable ::v-deep .el-form-item {
  margin: 22px 0;
}
</style>
